import React from "react";
import { Input, Select } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { STATUS_COLOR_MAP } from "../../hooks/useBotFilters";

const { Option } = Select;

const STATUS_OPTIONS = [
  { label: "全部", value: "all" },
  { label: "在线", value: "在线" },
  { label: "离线", value: "离线" },
  { label: "启动中", value: "启动中" },
  { label: "错误", value: "错误" },
];

/**
 * 假人筛选栏 — 服务器选择 + 状态筛选按钮 + 搜索框
 */
const BotFilterBar = ({
  filterServer,
  filterStatus,
  searchText,
  serverList,
  loading,
  onServerChange,
  onStatusChange,
  onSearchChange,
}) => {
  return (
    <div className="botcontrol-header">
      <div className="botcontrol-filter-section">
        <div className="botcontrol-filter-left">
          <div className="botcontrol-filter-group">
            <span className="botcontrol-filter-label">假人筛选:</span>
            <div className="botcontrol-filter-group-1">
              <Select
                value={filterServer}
                onChange={onServerChange}
                className="botcontrol-server-select"
                placeholder="选择服务器"
                disabled={loading}
              >
                <Option value="all">全部服务器</Option>
                {serverList
                  .filter((server) => server !== "all")
                  .map((server) => (
                    <Option key={server} value={server}>
                      {server}
                    </Option>
                  ))}
              </Select>

              <div className="botcontrol-filter-right">
                <div className="botcontrol-search-box">
                  <Input
                    placeholder="搜索假人名..."
                    prefix={<SearchOutlined />}
                    value={searchText}
                    onChange={(e) => onSearchChange(e.target.value)}
                    className="botcontrol-search-input"
                    disabled={loading}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="botcontrol-filter-group">
            <span className="botcontrol-filter-label">状态筛选:</span>
            <div className="botcontrol-filter-buttons">
              {STATUS_OPTIONS.map((opt) => (
                <button
                  key={opt.value}
                  className={`botcontrol-filter-btn ${filterStatus === opt.value ? "active" : ""}`}
                  onClick={() => onStatusChange(opt.value)}
                  disabled={loading}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BotFilterBar;
